import React, { useState, useEffect } from 'react';

import BackDrop from '../../shared/backdropDE';
import ErrorSnackbar from '../error-snackbar';
import MuiAlert from '@mui/material/Alert';
import * as FileSaver from 'file-saver';
import XLSXStyle from 'sheetjs-style';
import moment from 'moment';
import { getUser } from '../../shared/auth-service';
import dayjs from 'dayjs';

import {
    getColumns,
    getData,
    getAllAirports,
    getMonthsView,
    getDataExport,
    getDataExport_ORI,
    getZones
} from './logic';

import {
    Grid,
    Select,
    OutlinedInput,
    CircularProgress,
    Tooltip,
    Typography,
    MenuItem,
    InputLabel,
    FormControl,
    TextField,
    Box,
    Snackbar,
    Divider,
    FormControlLabel,
    Switch
} from "@mui/material";
import Fab from '@mui/material/Fab';
import { green } from '@mui/material/colors';
import CheckIcon from '@mui/icons-material/Check';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import BadgeIcon from '@mui/icons-material/Badge';
import DownloadIcon from '@mui/icons-material/Download';
import DownloadDoneIcon from '@mui/icons-material/DownloadDone';

import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

import DataTable from '../../shared/data-table';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const ShiftHistory = () => {
    const user = getUser();
    const [loading, setLoading] = useState(true);
    const [zones, setZones] = useState([]);
    const [zone, setZone] = useState('');
    const [error, setError] = useState(null);
    const [employeeId, setEmployeeId] = useState('');
    const [startDate, setStartDate] = useState(new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1));
    const [endDate, setEndDate] = useState(new Date((new Date()).getFullYear(), (new Date()).getMonth() + 1, 0));
    const [base, setBase] = useState('');
    const [monthsView, setMontsView] = useState('');
    const [loadingRows, setLoadingRows] = useState(false);
    const [loadingExport, setLoadingExport] = useState(false);
    const [abbreviate, setAbbreviate] = useState(true);

    const [openSnackBar, setOpenSnackBar] = useState(false);
    const [severetySnackBar, setSeveretySnackBar] = useState(false);
    const [messageSnackBar, setMessageSnackBar] = useState(false);

    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';

    const [columns, setcolumns] = useState([]);
    const [data, setData] = useState([]);
    const [airports, setAirports] = useState([]);
    const [showTable, setShowTable] = useState(false);


    const companyId = user.countryCode.split('-')[0];
    const company = user.countryCode.split('-')[1];
    const temporalId = user.temporalId;

    useEffect(() => {
        const fetchData = async () => {
            if (loading) {
                try {
                    const zonesData = await getZones(); // { zones: [...] }
                    //console.log(zonesData.zones);

                    setZones(zonesData.zones || []);
                    setZone('');
                    var MonthsView = await getMonthsView(dayjs(startDate).toDate(), dayjs(endDate).toDate()); // Obtener la vista de meses
                    var data = []; // Obtener los datos según el filtro de consulta
                    var dataColumns = await getColumns(data); // Obtener las columnas para los datos

                    // Configuración adicional del estado basado en la posición del empleado (comentado)
                    // var temp = user.employeePosition.employeePositionOptions.find((x) => x.code === 'DEOP0009');
                    // if(temp !== undefined){
                    //     setAirports(airportsData);
                    // }else{
                    //     setAirports([user.airport]);
                    // }

                    var airportsData = [...user.airports];
                    setAirports(airportsData); // Actualiza el estado con los datos de aeropuertos del usuario

                    setMontsView(MonthsView); // Actualiza el estado con la vista de meses
                    setcolumns(dataColumns); // Actualiza el estado con las columnas de datos
                    setData(data); // Actualiza el estado con los datos
                    setLoading(false); // Indica que la carga de datos ha terminado
                } catch (error) {
                    setError(error.message); // Establece un mensaje de error en caso de que ocurra uno
                    setLoading(false); // Indica que la carga de datos ha terminado (también en caso de error)
                }
            }
        };

        fetchData(); // Ejecuta la función fetchData
    }, [loading, user.airports, startDate, endDate]);

    const [successReload, setSuccessReload] = React.useState(false);
    const timer = React.useRef();
    const buttonSx = {
        ...(successReload && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    const [successExport, setSuccessExport] = React.useState(false);
    const buttonSxExport = {
        ...(successExport && {
            bgcolor: green[500],
            '&:hover': {
                bgcolor: green[700],
            },
        }),
    };

    const handleChangeStartDate = async (e) => {
        setStartDate(e);
        var MonthsView = await getMonthsView(e, dayjs(endDate).toDate());
        setMontsView(MonthsView);

    };

    function formatDate(date) {
        return dayjs(date).format('YYYY-MM-DD');
    }

    const handleChangeEndDate = async (e) => {
        setEndDate(e);
        var MonthsView = await getMonthsView(dayjs(startDate).toDate(), e);
        setMontsView(MonthsView);
        //console.log(MonthsView);
    };

    const handleReloadQuery_ORI = async () => {
        if (!loadingRows) {

            setSuccessReload(false);
            setLoadingRows(true);

            var MonthsView = await getMonthsView(dayjs(startDate).toDate(), dayjs(endDate).toDate());
            setMontsView(MonthsView);

            var dataColumns = await getColumns(startDate, endDate);

            var data = await getData(QueryFilter());

            setcolumns(dataColumns);
            setData(data);

            setSuccessReload(true);
            setLoadingRows(false);

            timer.current = window.setTimeout(() => {
                setSuccessReload(false);
            }, 2000);
        }
    };

    const handleReloadQuery = async () => {
        if (!loadingRows) {
            setSuccessReload(false);
            setLoadingRows(true);

            var MonthsView = await getMonthsView(dayjs(startDate).toDate(), dayjs(endDate).toDate());
            setMontsView(MonthsView);

            var data = await getData(QueryFilter());
            var dataColumns = await getColumns(data);

            setcolumns(dataColumns);
            setData(data);
            setShowTable(true);

            setSuccessReload(true);
            setLoadingRows(false);

            timer.current = window.setTimeout(() => {
                setSuccessReload(false);
            }, 2000);
        }
    };

    const handleAbbreviatedChange = (event) => {
        setAbbreviate(event.target.checked);
    };


    const handleCloseSnackBar = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenSnackBar(false);
    };

    function QueryFilter() {
        var paramsQuery = '';

        if (employeeId !== '' && employeeId != null)
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'Employee=' + employeeId;


        if (companyId !== '' && companyId != null)
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'CompanyId=' + companyId;


        if (base !== '' && base != null)
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'AirportId=' + base;

        if (zone !== '' && zone != null)
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'Zone=' + zone;

        if (temporalId !== '' && temporalId != null)
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'TemporalId=' + temporalId;

        if (startDate !== '' && startDate !== null)
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'StartDate=' + formatDate(startDate);


        if (endDate !== '' && endDate !== null)
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'EndDate=' + formatDate(endDate);


        if (abbreviate)
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'Abbreviate=1';
        else
            paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'Abbreviate=0';


        paramsQuery = (paramsQuery !== '' ? paramsQuery + '&' : '') + 'employeeId=' + user.employeeId;

        paramsQuery = paramsQuery !== '' ? '?' + paramsQuery : paramsQuery;

        return paramsQuery;
    }

    function OpenMessage(message, severety) {
        setMessageSnackBar(message);
        setSeveretySnackBar(severety);
        setOpenSnackBar(true);
    };

    const handleExport = async () => {
        setLoadingExport(true);

        const user = getUser();
        const isTalmaEcuador = user.countryCode.split('-')[1] === 'TALMA ECUADOR';

        const rows = await getData(QueryFilter());
        const wb = XLSXStyle.utils.book_new();

        // Agrupar fechas por mes
        const dynamicDates = new Set();
        rows.forEach(row => {
            Object.keys(row).forEach(key => {
                if (/^\d{4}-\d{2}-\d{2}$/.test(key)) {
                    dynamicDates.add(key);
                }
            });
        });

        const sortedDates = [...dynamicDates].sort();
        const groupedDates = sortedDates.reduce((acc, dateKey) => {
            const month = dayjs(dateKey).format('YYYY-MM');
            if (!acc[month]) acc[month] = [];
            acc[month].push(dateKey);
            return acc;
        }, {});

        // Crear una hoja por cada mes
        for (const [month, dateKeys] of Object.entries(groupedDates)) {
            const sheetData = [];

            // Encabezado
            const header = [
                { v: 'Identificación', t: 's' },
                { v: 'Apellidos', t: 's' },
                { v: 'Nombres', t: 's' },
                { v: 'Base/Aeropuerto', t: 's' },
                { v: 'Área', t: 's' },
                ...(isTalmaEcuador ? [] : [{ v: 'Zona', t: 's' }]),
                ...dateKeys.map(d => ({ v: dayjs(d).format('DD'), t: 's' }))
            ];
            sheetData.push(header);

            // Filas de empleados
            rows.forEach(row => {
                const excelRow = [
                    { v: row.employeeId, t: 's' },
                    { v: row.lastName, t: 's' },
                    { v: row.name, t: 's' },
                    { v: row.airport, t: 's' },
                    { v: row.area, t: 's' },
                    ...(isTalmaEcuador ? [] : [{ v: row.zona, t: 's' }])
                ];

                dateKeys.forEach(dateKey => {
                    const cellData = row[dateKey];
                    if (cellData) {
                        const displayValue =
                            cellData.shift && cellData.abbreviate
                                ? `${cellData.shift}_${cellData.abbreviate}`
                                : cellData.abbreviate || cellData.shift || '';
                        const backgroundColor = cellData.color?.replace('#', '') || null;
                        excelRow.push({
                            v: displayValue,
                            t: 's',
                            s: backgroundColor ? {
                                fill: {
                                    patternType: 'solid',
                                    fgColor: { rgb: backgroundColor }
                                }
                            } : {}
                        });
                    } else {
                        excelRow.push({ v: '', t: 's' });
                    }
                });

                sheetData.push(excelRow);
            });

            // Crear hoja
            const ws = XLSXStyle.utils.aoa_to_sheet(sheetData);
            const sheetName = dayjs(month).format('MMMM YYYY');
            XLSXStyle.utils.book_append_sheet(wb, ws, sheetName);
        }

        const fileName = "ReporteHistorico_" + moment(new Date()).format('YYYYMMDDHHmmss');
        const excelBuffer = XLSXStyle.write(wb, { bookType: 'xlsx', type: 'array' });
        const dataB = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(dataB, fileName + fileExtension);

        setSuccessExport(true);
        setLoadingExport(false);

        timer.current = window.setTimeout(() => {
            setSuccessExport(false);
        }, 2000);

        OpenMessage(`Archivo ${fileName} exportado correctamente`, "success");
    };


    const handleExport_V2 = async () => {
        setLoadingExport(true);

        const rows = await getDataExport(QueryFilter());

        const wb = XLSXStyle.utils.book_new();
        const ws = XLSXStyle.utils.aoa_to_sheet(rows);

        for (const cellAddress in ws) {
            if (ws.hasOwnProperty(cellAddress)) {
                const cell = ws[cellAddress];
                const cellRef = XLSXStyle.utils.decode_cell(cellAddress);

                if (cellRef.r === 0) {
                    cell.s = {
                        font: { bold: true },
                        alignment: { horizontal: 'center' },
                    };
                }
            }
        }

        XLSXStyle.utils.book_append_sheet(wb, ws, 'data');

        var fileName = "ReporteHistorico_" + moment(new Date()).format('YYYYMMDDHHmmss');
        const excelBuffer = XLSXStyle.write(wb, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(blob, fileName + fileExtension);

        setSuccessExport(true);
        setLoadingExport(false);

        timer.current = window.setTimeout(() => {
            setSuccessExport(false);
        }, 2000);

        OpenMessage("Excel " + fileName + " exportado correctamente", "success");
    }

    if (loading) {
        return (<BackDrop />);
    }

    if (error) {
        return (<ErrorSnackbar message={error} />);
    }

    const getRowId = (row) => row.employeeId;

    return (
        <>
            <Grid container spacing={2} alignItems="center" flexWrap="wrap">

                {/* Título */}
                <Grid item xs={12}>
                    <Typography style={{ color: '#00B0EF', fontWeight: 'bold', fontSize: '24px' }}>
                        Historial de <span style={{ color: '#1A3072' }}>Turnos</span>
                    </Typography>
                </Grid>

                {/* Meses visibles */}
                <Grid item xs={12}>
                    <Typography variant="h7" style={{ color: '#00b0ef' }} fontWeight="bold">
                        {monthsView.map(item => (
                            <span key={`${item.Year}-${item.Month}`} style={{ color: '#1a3072', marginRight: 6 }}>
                                {monthsView.length > 12 ? item.Year + '-' : ''}{item.Month}
                            </span>
                        ))}
                    </Typography>
                </Grid>

                {/* Fecha Desde */}
                <Grid item xs={6} sm={3} md={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Fecha Desde"
                            inputFormat="DD/MM/YYYY"
                            value={dayjs(startDate)}
                            onChange={(e) => { setStartDate(e); handleChangeStartDate(e) }}
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* Fecha Hasta */}
                <Grid item xs={6} sm={3} md={2}>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                            label="Fecha Hasta"
                            inputFormat="DD/MM/YYYY"
                            value={dayjs(endDate)}
                            onChange={(e) => { setEndDate(e); handleChangeEndDate(e) }}
                            renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                        />
                    </LocalizationProvider>
                </Grid>

                {/* Base */}
                <Grid item xs={6} sm={2} md={2}>
                    <FormControl size="small" fullWidth>
                        <InputLabel>Base</InputLabel>
                        <Select value={base} onChange={(e) => setBase(e.target.value)} label="Base">
                            {airports.map(item => (
                                <MenuItem key={item.id} value={item.id}>{item.code}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Zona 
                Se oculta para Talma Ecuador */}
                {company !== 'TALMA ECUADOR' && (
                    <Grid item xs={6} sm={2} md={2}>
                        <FormControl size="small" fullWidth>
                        <InputLabel>Zona</InputLabel>
                        <Select value={zone} onChange={(e) => setZone(e.target.value)} label="Zona">
                            {zones.map(item => (
                            <MenuItem key={item.id} value={item.id}>{item.description}</MenuItem>
                            ))}
                        </Select>
                        </FormControl>
                    </Grid>
                    )}

                {/* Documento */}
                <Grid item xs={6} sm={3} md={2}>
                    <FormControl size="small" fullWidth>
                        <InputLabel htmlFor="search-doc">Documento</InputLabel>
                        <OutlinedInput
                            id="search-doc"
                            type="text"
                            value={employeeId}
                            onChange={(e) => setEmployeeId(e.target.value)}
                            endAdornment={<BadgeIcon />}
                            label="Documento"
                        />
                    </FormControl>
                </Grid>

              {/* Botones + Switch */}
            <Grid item xs={12} sm={6} md={2}>
            <Box display="flex" alignItems="center" justifyContent="flex-start" sx={{ flexWrap: 'nowrap' }}>
                 {/* Botón Filtrar */}
                <Tooltip title="Filtrar">
                    <Box sx={{ position: 'relative', mr: 1 }}>
                        <Fab size="small" color="primary" sx={buttonSx} onClick={handleReloadQuery}>
                        {successReload ? <CheckIcon /> : <FilterAltIcon />}
                        </Fab>
                        {loadingRows && (
                        <CircularProgress
                            size={50}
                            sx={{ color: green[500], position: 'absolute', top: -4.9, left: -5, zIndex: 1 }}
                        />
                        )}
                    </Box>
                </Tooltip>
                    
                {/* Exportar */}
                <Tooltip title="Exportar a Excel">
                    <Box sx={{ position: 'relative', mr: 2 }}>
                        <Fab size="small" color="primary" sx={buttonSxExport} onClick={handleExport}>
                        {successExport ? <DownloadDoneIcon /> : <DownloadIcon />}
                        </Fab>
                        {loadingExport && (
                        <CircularProgress
                            size={50}
                            sx={{ color: green[500], position: 'absolute', top: -4.9, left: -5, zIndex: 1 }}
                        />
                        )}
                    </Box>
                </Tooltip>

            {/* Switch Abreviados */}
            <Tooltip title="Incluye abreviaturas en el reporte">
                <Box component="span" display="flex" alignItems="center" sx={{ minWidth: 100 }}>
                    <Typography variant="body2" sx={{ mr: 1, whiteSpace: 'nowrap' }}>
                    Abreviados
                    </Typography>
                    <Switch
                    checked={abbreviate}
                    onChange={handleAbbreviatedChange}
                    size="small"
                    />
                </Box>
            </Tooltip>

            </Box>
            </Grid>
            </Grid>


            {showTable && (
                <DataTable
                    columns={columns}
                    rows={data}
                    getRowId={getRowId}
                    sx={{
                        '& .MuiDataGrid-columnHeaderTitle': {
                            fontWeight: 'bold',
                        }
                    }}
                />
            )}


            <Snackbar open={openSnackBar} autoHideDuration={4000} onClose={handleCloseSnackBar}>
                <Alert onClose={handleCloseSnackBar} severity={severetySnackBar} sx={{ width: '100%' }}>
                    {messageSnackBar}
                </Alert>
            </Snackbar>
        </>
    );
};

export default ShiftHistory;
